// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_1SQ_X","checkbox__label":"IQtqF","checkbox__input":"ony5n","clearCookiesButton":"_1DHYq"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/index.sass
// module id = 1462
// module chunks = 1